import { generateResources } from '@/shared/utils/common.utils';
import sharedLocales from '@/shared/locales';
import authLocales from './auth/locales';
import dashboardLocales from './dashboard/locales';
import customersLocales from './customers/locales';
import userLocales from './users/locales';
import tenantLocales from './tenants/locales';
import revenueLocales from './revenue/locales';
import payoutHistoryLocales from './payout-history/locales';
import settingsLocales from './settings/locales/index';
import notificationLocales from './notifications/locales/index';
import moduleConfig from './configs';

const modules = {
  auth: authLocales,
  dashboard: dashboardLocales,
  customers: customersLocales,
  users: userLocales,
  tenants: tenantLocales,
  revenue: revenueLocales,
  payoutHistory: payoutHistoryLocales,
  shared: sharedLocales,
  settings: settingsLocales,
  notification:notificationLocales
};

const { supportedLanguages, features } = moduleConfig;

const localesConfig = generateResources({
  supportedLanguages,
  features,
  modules,
});

export default localesConfig;
